import { Box, SvgIcon } from '@mui/material';
import { common } from '@mui/material/colors';

import { neutrals } from '@toolbox/style/theme/common/ThemeProvider/colors';

import type React from 'react';
import type { BaseIconProps } from '../types';

export const CheckBoxIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" fillRule="evenodd" {...props}>
      <Box
        sx={() => ({
          fill: common.white,
          stroke: neutrals.dark,
        })}
        component="rect"
        x="4"
        y="4"
        width={16}
        height={16}
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
